import { apiClient } from './api'
import { User, LoginCredentials, RegisterData } from '@/types'

interface LoginResponse {
  user: User
  token: string
}

interface RegisterResponse {
  user: User
  token: string
}

interface RefreshTokenResponse {
  token: string
}

export const authService = {
  // 用户登录
  login: (credentials: LoginCredentials) => {
    return apiClient.post<LoginResponse>('/auth/login', credentials)
  },

  // 用户注册
  register: (data: RegisterData) => {
    return apiClient.post<RegisterResponse>('/auth/register', data)
  },

  // 获取当前用户信息
  getCurrentUser: () => {
    return apiClient.get<{ user: User }>('/auth/me')
  },

  // 刷新token
  refreshToken: () => {
    return apiClient.post<RefreshTokenResponse>('/auth/refresh')
  },

  // 用户登出
  logout: () => {
    return apiClient.post('/auth/logout')
  },

  // 忘记密码
  forgotPassword: (email: string) => {
    return apiClient.post('/auth/forgot-password', { email })
  },

  // 重置密码
  resetPassword: (token: string, newPassword: string) => {
    return apiClient.post('/auth/reset-password', { token, newPassword })
  },

  // 发送短信验证码
  sendSmsCode: (phone: string, purpose: 'LOGIN' | 'REGISTER') => {
    return apiClient.post('/auth/send-sms', { phone, purpose })
  },

  // 手机号登录
  phoneLogin: (phone: string, code: string) => {
    return apiClient.post<LoginResponse>('/auth/phone-login', { phone, code })
  },

  // 手机号注册
  phoneRegister: (phone: string, code: string, username?: string, couponCode?: string) => {
    return apiClient.post<RegisterResponse>('/auth/phone-register', { phone, code, username, couponCode })
  },
}
